import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface QueueState {
  list: any[];
  total: number;
  loading: boolean;
}

const initialState: QueueState = {
  list: [],
  total: 0,
  loading: false
};

export const queuesSlice = createSlice({
  name: "queues",
  initialState,
  reducers: {
    setQueueLoading: (state, action) => {
      state.loading = action.payload;
    },

    setQueus: (state, action: PayloadAction<any>) => {
      const queues = action.payload?.queues || [];

      state.total = action.payload?.queue_total || 0;

      state.list = queues.sort((a: any, b: any) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA;
      });
    },

    removeQueus: (state) => {
      state.list = [];
      state.total = 0;
    },

    removeSingleQueue: (state, action: PayloadAction<any>) => {
      state.list = state.list.filter(
        (item) => item.query_id !== action.payload
      );
    },
  },
});

export const { setQueus, removeQueus, removeSingleQueue, setQueueLoading } =
  queuesSlice.actions;

export const selectQueus = (state: RootState) => state.queues.list;
export const selectTotal = (state: RootState) => state.queues.total;
export const selectLoading = (state: RootState) => state.queues.loading;

export default queuesSlice.reducer;